const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.84,
    height: 7.088,
    viewBox: "0 0 11.84 7.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__filter",
    transform: "translate(-3.4 -22.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_412",
    d: "M14.649 24.081H3.991a.591.591 0 010-1.181h10.658a.591.591 0 010 1.181zm-8.873 1.772h7.1a.591.591 0 110 1.181h-7.1a.6.6 0 01-.591-.591.581.581 0 01.591-.59zm1.772 2.953h3.544a.591.591 0 110 1.181H7.548a.6.6 0 01-.591-.591.589.589 0 01.591-.589z",
    "data-name": "Path 412",
    style: {
      fill: "#a4b9dd",
      fillrule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderFilter);
export default __webpack_public_path__ + "static/media/HeaderFilter.154a28c13f41973f1e9ed4d28e0fba64.svg";
export { ForwardRef as ReactComponent };